import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import {Content} from '../_models';
import { Observable, throwError } from 'rxjs';
import { ArrayResponse, BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';
import { ContentEpisode } from '../_models/content-episode';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  constructor(private http: HttpClient) { }

  addContent(data): Observable<BaseResponse> {
    return this.http.post(`${environment.apiUrl}/tx/content/save`, JSON.stringify(data))
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getAllContent(filter: any): Observable<ListResponse>  { //listing
    return this.http.post(`${environment.apiUrl}/tx/content/list`, JSON.stringify(filter))
    .pipe(
      map((data: ListResponse) => {
        if(data.status == 1 && data.data.list == undefined){
          return null;
        }else{
          return new ListResponse().deserialize(data, Content);
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getContent(id: any): Observable<Content> { //detail
    return this.http.get(`${environment.apiUrl}/tx/content/find/${id}`)
    .pipe(
      map((data: BaseResponse) => {
        return new Content().deserialize(data.data);
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  updateContent(data): Observable<BaseResponse> {
    return this.http.post(`${environment.apiUrl}/tx/content/update/${data.id}`, JSON.stringify(data))
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  deleteContent(id: any): Observable<BaseResponse> {
    return this.http.delete(`${environment.apiUrl}/tx/content/delete/${id}`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  addEpisode(contentId:any, data): Observable<BaseResponse> {
    return this.http.post(`${environment.apiUrl}/tx/content/episode/${contentId}/save`, JSON.stringify(data))
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getAllEpisode(contentId: any, filter: any): Observable<ListResponse>  { //listing
    return this.http.post(`${environment.apiUrl}/tx/content/episode/${contentId}/list`, JSON.stringify(filter))
    .pipe(
      map((data: ListResponse) => {
        if(data.status == 1 && data.data.list == undefined){
          return null;
        }else{
          return new ListResponse().deserialize(data, ContentEpisode);
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  getEpisode(id: any): Observable<ContentEpisode> { //detail
    return this.http.get(`${environment.apiUrl}/tx/content/episode/find/${id}`)
    .pipe(
      map((data: BaseResponse) => {
        return new ContentEpisode().deserialize(data.data);
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  updateEpisode(data): Observable<BaseResponse> {
    return this.http.post(`${environment.apiUrl}/tx/content/episode/update/${data.id}`, JSON.stringify(data))
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  deleteEpisode(id: any): Observable<BaseResponse> {
    return this.http.delete(`${environment.apiUrl}/tx/content/episode/delete/${id}`)
    .pipe(
      map((data: BaseResponse) => {
        return data;
      }),
      catchError(error => throwError(error.message || error))
    );
  }

}
